import { render, staticRenderFns } from "./aside.prices.vue?vue&type=template&id=f44570ac&scoped=true&"
import script from "./aside.prices.vue?vue&type=script&lang=js&"
export * from "./aside.prices.vue?vue&type=script&lang=js&"
import style0 from "./aside.prices.vue?vue&type=style&index=0&id=f44570ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44570ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f44570ac', component.options)
    } else {
      api.reload('f44570ac', component.options)
    }
    module.hot.accept("./aside.prices.vue?vue&type=template&id=f44570ac&scoped=true&", function () {
      api.rerender('f44570ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/layout/aside.prices.vue"
export default component.exports